import { useMemo } from 'react';
import { useGetFundDetailsData } from '../../../../hooks/useGetFundDetailsData';
import { sortPieChartItems } from './FundCompositionPieChart.utils';
import type { IFundCompositionPieChartHandlerReturn } from './FundCompositionPieChart.types';

export const useFundCompositionPieChartHandler =
  (): IFundCompositionPieChartHandlerReturn => {
    const { data } = useGetFundDetailsData({
      enabled: false,
    });

    const items = data?.assetCompesitions || [];

    return useMemo(() => {
      if (items.length === 0) {
        return {
          items: [],
        };
      }
      const pieChartItems = items.map((item) => {
        return {
          name: `${item.percent}٪ ${item.title}`,
          value: item.percent,
          color: item.color,
        };
      });
      return {
        items: sortPieChartItems(pieChartItems),
      };
    }, [items]);
  };
